import AverageDepth from './AverageDepth'
export default AverageDepth
